import React, { useMemo } from 'react';

import { FormControl, MenuItem, Select } from '@material-ui/core';
import styled from 'styled-components';

import { sendAddedTargetQuarterEvent, sendChangedTargetQuarterEvent } from 'constants/mixpanelHelper';

import { Typography13 } from 'uiToolkit/Typography';

export const StyledCompetencyPeriodSelect = styled(Select)`
  height: 2rem;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }

  .MuiSelect-root {
    padding: 4px 16px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .MuiOutlinedInput-input {
    color: ${(props) => props.theme.palette.primary.main};
  }

  &:hover {
    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) => props.theme.palette.primary.main};
    }
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 1rem;
  &:hover {
    background-color: ${(props) => props.theme.palette.background.lighterBlue};
  }
`;

const CompetencyPeriodSelect = ({
  selectedPeriod,
  competencyId,
  subCompetencyId = null,
  handleTargetDateChange,
  levelUpTargetDates = [],
}) => {
  const handleOnChange = (ev) => {
    ev.stopPropagation();
    const targetPeriodStart = levelUpTargetDates.find(({ periodName }) => periodName === ev.target.value);

    if (selectedPeriod) {
      sendChangedTargetQuarterEvent({
        eventProperties: {
          from: selectedPeriod?.periodName,
          to: targetPeriodStart.periodName,
        },
      });
    } else {
      sendAddedTargetQuarterEvent({
        eventProperties: {
          to: targetPeriodStart.periodName,
        },
      });
    }

    handleTargetDateChange({
      competencyId,
      subCompetencyId,
      targetPeriodStart,
    });
  };

  const availableLevelUpDates = useMemo(() => {
    const matchedDate = levelUpTargetDates.findIndex((date) => date.periodName === selectedPeriod?.periodName);
    const mappedLevelUpTargetDates = levelUpTargetDates.map((date) => ({
      ...date,
      disabled: false,
    }));

    if (matchedDate > -1 || !selectedPeriod) return mappedLevelUpTargetDates;
    return [
      {
        periodName: selectedPeriod.periodName,
        disabled: true,
      },
      ...mappedLevelUpTargetDates,
    ];
  }, [levelUpTargetDates, selectedPeriod]);

  return (
    <FormControl>
      <StyledCompetencyPeriodSelect
        margin="dense"
        displayEmpty
        variant="outlined"
        placeholder="Select Date"
        value={selectedPeriod ? selectedPeriod.periodName : ''}
        onChange={handleOnChange}
        IconComponent={() => null}
      >
        <StyledMenuItem disabled value="">
          <Typography13>Add Quarter</Typography13>
        </StyledMenuItem>
        {availableLevelUpDates.map((period) => (
          <StyledMenuItem key={period.periodName} value={period.periodName} disabled={period.disabled}>
            <Typography13 color={period.disabled ? 'inherit' : 'primary'}>{period.periodName}</Typography13>
          </StyledMenuItem>
        ))}
      </StyledCompetencyPeriodSelect>
    </FormControl>
  );
};

export default CompetencyPeriodSelect;
